import {
  IPsrPriorityService,
  IPsrPriorityServiceItem,
  IPsrServiceCategory,
} from "@/models/psr/psr.types"

export class PsrPriorityService implements IPsrPriorityService {
  id: number
  title: string
  label: string
  description: string
  alwaysOn: boolean
  availableNow: boolean
  serviceItems: Array<IPsrPriorityServiceItem>
  isInternal?: boolean
  category?: IPsrServiceCategory

  constructor(service: IPsrPriorityService) {
    this.id = service.id
    this.title = service.title
    this.label = service.label
    this.description = service.description
    this.alwaysOn = service.alwaysOn
    this.availableNow = service.availableNow
    this.serviceItems = service.serviceItems ?? []
    this.isInternal = service.isInternal
    this.category = service.category
  }
}
